(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-vx-inspect]:not([data-ready])').forEach(section => {
      const tabs = [...section.querySelectorAll('[data-vx-tab]')];
      const panels = [...section.querySelectorAll('[data-vx-panel]')];
      const list = section.querySelector('[data-vx-tablist]');
      if (!tabs.length || tabs.length !== panels.length) return;
      function select(index, focus = false) {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          if (i !== index) panels[i].querySelectorAll('video').forEach(video => video.pause());
        });
        if (focus) tabs[index].focus();
      }
      list.setAttribute('role', 'tablist');
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      section.dataset.ready = 'true';
      list.hidden = false;
      select(0);
    });
    root.querySelectorAll('[data-vx-compare]:not([data-ready])').forEach(section => {
      const controls = [...section.querySelectorAll('[data-vx-model]')];
      const feedback = section.querySelector('[data-vx-feedback]');
      section.querySelector('[data-vx-filters]').hidden = false;
      section.dataset.ready = 'true';
      controls.forEach(input => input.addEventListener('change', () => {
        if (controls.filter(item => item.checked).length < 2) {
          input.checked = true;
          feedback.textContent = section.dataset.minimum;
          return;
        }
        feedback.textContent = '';
        controls.forEach((control, i) => section.querySelectorAll(`[data-vx-column="${i}"]`).forEach(cell => cell.hidden = !control.checked));
      }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
